import { createContext, useContext } from "react";
import type { ApiClient } from "./auth/apiClient";

/**
 * Context for the authenticated API client. Separated from the provider
 * component so react-refresh treats the provider as component-only.
 *
 * The ApiClient is created once per MSAL instance + config pair and provides
 * authenticated fetch with automatic Bearer token attachment.
 */
export const ApiClientContext = createContext<ApiClient | null>(null);

/**
 * Consumes the authenticated API client from context.
 *
 * Throws if called outside the provider — hooks that depend on authenticated
 * fetch cannot meaningfully degrade without it.
 */
export function useApiClient(): ApiClient {
    const client = useContext(ApiClientContext);
    if (client === null) {
        throw new Error(
            "useApiClient must be called within a component tree that provides ApiClientContext. " +
                "Ensure ExperienceShell (or an ApiClientContext.Provider) is an ancestor.",
        );
    }
    return client;
}
